/** 정비소 상세 CTA 버튼(PC/모바일 공통)에서 이동할 AppsFlyer OneLink */
export const PLACE_DETAIL_APP_DOWNLOAD_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/kf92rufg'

/** 정비소 상세 프로모션 배너(PC/모바일 공통)에서 이동할 AppsFlyer OneLink */
export const PLACE_DETAIL_PROMOTION_BANNER_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/oligd48b'

/** 시공 실적 '앱에서 시공 후기 자세히 보기' CTA OneLink */
export const PLACE_DETAIL_PERFORMANCE_MORE_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/wefxz43l'

/** 리뷰 '앱으로 편하게 보기'(리뷰 더보기) CTA OneLink */
export const PLACE_DETAIL_REVIEW_MORE_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/z5wuh0rn'

/** 프로모션 배너 클릭 시 데스크탑에서 이동할 경로 (모바일은 원링크) */
export const MYCLE_HOME_URL = 'https://mycle.co.kr'

/** 상단 프로모션 배너 이미지 (첫구매 2만원 쿠폰) */
export const PLACE_DETAIL_PROMOTION_BANNER_IMAGE_URL =
  'https://mycle.co.kr/resources/images/contents/img_seo_promotion_banner_20000.png'
